import AjaxRequest from '../AjaxRequest';
import CallbackHandler from '../CallbackHandler';
import AxiosRequest from '../AxiosRequest';

export default class User {
    constructor(user_id) {
        this.results = [];
        this.user_id = user_id;
        this.user_roles = [];
        this.user_details = {};
        this.output = '';
    }

    async get(url, data = null, func, message) {
        const self = this;
        const callback = new CallbackHandler();
        const api = new AjaxRequest(url, data);

        await api.getRequest().then(function (response) {
            if (response.status == 200) {
                return self.output = callback.handleSuccess(response, 'output');
            } else {
                callback.handleError(
                    self.constructor.name,
                    func,
                    message,
                    response
                );

                self.output = 'An error has occured, please try again';
            }
        })
    }

    async post(url, data = null, func, message) {
        const self = this;
        const callback = new CallbackHandler();
        const api = new AjaxRequest(url, data);

        await api.postRequest().then(function (response) {
            if (response.status == 200) {
                return self.output = callback.handleSuccess(response, 'output');
            } else {
                callback.handleError(
                    self.constructor.name,
                    func,
                    message,
                    response
                );

                self.output = 'An error has occured, please try again';
            }
        })
    }

    create(data) {
        return new AxiosRequest().post(`admin/user`, data);
    }

    createMilitaryUser(data) {
        return new AxiosRequest().post(`admin/user/military`, data);
    }

    async disableUser() {
        await this.get(`admin/user/${this.user_id}/disable`, null, 'disableUser', "Error while disabling user. Please refresh.");
        return this.output;
    }

    async enableUser() {
        await this.get(`admin/user/${this.user_id}/enable`, null, 'enableUser', "Error while enabling user. Please refresh.");
        return this.output;
    }

    async searchUsers(search, roleName = null) {
        const data = {
            search: search,
            role: roleName
        };
        await this.post(`admin/user/search`, data, 'searchUsers', "Error while searching users. Please refresh.");
        return this.output;
    }

    async getLatest() {
        await this.get(`admin/users/latest`, null, 'getLatest', "Error while getting users. Please refresh.");
        return this.output;
    }

    async getDetails() {
        await this.get(`admin/user/find/${this.user_id}`, null, 'getDetails', "Error while getting user details. Please refresh.");
        return this.output;
    }

    async getRoles() {
        await this.post(`admin/user/${this.user_id}/roles`, null, 'getRoles', "Error while fetching user roles. Please refresh.");
        return this.output;
    }

    async getUserSchools() {
        await this.get(`admin/user/${this.user_id}/schools`, null, 'getUserSchools', "Error while fetching user schools. Please refresh.");
        return this.output;
    }

    async addSchool(school_id) {
        await this.get(`admin/user/${this.user_id}/addSchool/${school_id}`, null, 'addSchool', "Error while adding school to user. Please refresh.");
        return this.output;
    }

    async removeSchool(school_id) {
        await this.get(`admin/user/${this.user_id}/removeSchool/${school_id}`, null, 'removeSchool', "Error while removing school from user. Please refresh.");
        return this.output;
    }

    async getCounties(data) {
        await this.post('admin/user/counties', data, 'getCounties', 'Could not retrieve counties. Please refresh.')
        return this.output;
    }

    async getAdminCounties(user_id) {
        await this.get(`admin/user/${user_id}/getAdminCounties`, null, 'addCountyAdmin', "Error while addCountyAdmin. Please refresh.");
        return this.output;
    }

    async addCountyAdmin(data) {
        await this.post(`admin/user/${this.user_id}/addCountyAdmin`, data, 'addCountyAdmin', "Error while addCountyAdmin. Please refresh.");
        return this.output;
    }

    async removeCountyAdmin(data) {
        await this.post(`admin/user/${this.user_id}/removeCountyAdmin`, data, 'removeCountyAdmin', "Error while removeCountyAdmin. Please refresh.");
        return this.output;
    }

    async getUserPreferences() {
        await this.post(`admin/user/preferences`, null, 'admin/user/preferences', "Error while getting user preferences. Please refresh.");
        return this.output;
    }

    async updateUserName(data) {
        await this.post(`admin/user/${this.user_id}/updateUserName`, data, 'updateUserName', "Error while changing name. Please refresh.");
        return this.output;
    }

    async updateGuid() {
        await this.post(`admin/user/updateGuid`, null, 'updateGuid', "Error while updateGuid. Please refresh.");
        return this.output;
    }

    async adminChangePassword(data) {
        await this.post(`admin/user/${this.user_id}/adminChangePassword`, data, 'adminChangePassword', "Error while changing password.");
        return this.output;
    }
}
